import { BrandsQuery } from './brands-query';
export var endpoints = {
    brandsQuery: new BrandsQuery(),
};
